// ReturnModalShell.tsx
import { WizardStepKey } from "@dana/Services/DanaStandardReturnOrderService";
import translate from "@insite/client-framework/Translate";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import React from "react";
import { css } from "styled-components";

// --- Styles Interfaces and Objects ---
export interface ReturnModalShellStyles {
    modal?: ModalPresentationProps;
}

export const ReturnModalShellStyles: ReturnModalShellStyles = {
    modal: {
        size: 1140,
        sizeVariant: "large",
        cssOverrides: {
            headlineTypography: css`
                padding-right: 16px;
                margin-bottom: 0;
            `,
        },
    },
};

// Map step -> translation key
const HeadlineKeyByStep: Record<WizardStepKey, string> = {
    SELECT_ITEMS: "Select Part Numbers & Quantity to Return",
    CONFIRM_ITEMS: "Confirm Return",
    REASON_DISPOSITION: "Select Returning & Disposing Preference",
    INTERNAL_REF_ONLY: "Your Internal Return Reference Number (optional)",
    SHIPPING_CONTACT: "Return Freight Collect - Shipping Contact",
    FREIGHT_COLLECT: "Return Freight Collect Address",
    EMAIL_CONTACTS: "Email Confirmation",
    REVIEW: "Preview",
    SUBMIT_RESULT: "Return Authorization Request",
};

type Props = {
    styles: { modal?: unknown };
    isOpen: boolean;
    onClose: () => void;
    currentStep: WizardStepKey;
    children: React.ReactNode;
    Modal: React.ComponentType<any>;
};

const styles = ReturnModalShellStyles;

export const ReturnModalShell: React.FC<Props> = ({ isOpen, onClose, currentStep, children, Modal }) => {
    const key = HeadlineKeyByStep[currentStep] ?? "ReturnAuthorization";
    return (
        <Modal headline={translate(key)} isOpen={isOpen} handleClose={onClose} {...styles.modal}>
            {children}
        </Modal>
    );
};
